import options from '../options';
import Events from '../events';
import { buildGoogleParamsHash, getGoogleParams } from '../utils';
import SelectorMapping from '../SelectorMapping';

class SortHandler {
  sortingBy = 'relevance';

  constructor() {
    this.sortForm = document.querySelector(options.selectors.sortHandler);

    this.mount();
  }

  show() {
    this.sortForm.ariaHidden = false;
  }

  apply(sortValue) {
    if (sortValue === this.sortingBy) {
      return;
    }

    this.sortingBy = sortValue;

    const currentParams = getGoogleParams();
    currentParams.sort = sortValue;

    const updatedHash = buildGoogleParamsHash(currentParams);

    window.location.hash = updatedHash;
  }

  replaceGoogleSortForm() {
    const [sortContainer, sort] = SelectorMapping.get(
      'gsc-results__sort-container',
      'gsc-results__sort',
    );

    const googleSortContainer = document.querySelector(sortContainer);
    const googleSort = document.querySelector(sort);

    googleSort.classList.add('hide');
    googleSortContainer.appendChild(this.sortForm);

    this.show();
  }

  attachListeners() {
    this.sortForm.addEventListener('change', (e) => {
      const sortValue = e.target.value;
      window.dispatchEvent(Events.SortUpdatedEvent(sortValue));

      this.sortingBy = sortValue;
    });
  }

  mount() {
    this.attachListeners();
  }
}

export default SortHandler;
